
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Component } from 'vue-property-decorator';
import WidgetMixins from '../../mixins/WidgetMixins';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { numeric, required, max } from 'vee-validate/dist/rules';
import { mixins } from 'vue-class-component';
import AuthLayout, { IPanelRow } from './components/AuthLayout.vue';

extend('max', {
  ...max,
  message: `Maximum code length must be 6`,
});
extend('numeric', {
  ...numeric,
  message: 'Invalid input provided',
});
extend('required', {
  ...required,
  message: 'Field is required',
});

@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
    AuthLayout,
  },
})
export default class VerifyAccount extends mixins(WidgetMixins) {
  code: string = '';
  isThrottled: boolean = false;
  maxAllowedTimeToResendOTP: number = 30;
  handleResendTimer: number = 0;

  panelRows: IPanelRow[] = [
    {
      icon: 'mark_email_read',
      title: 'Check your inbox',
      text: 'The code arrives by email or SMS within a few seconds.',
    },
    {
      icon: 'schedule',
      title: 'Codes expire quickly',
      text: 'Request a new one any time if yours has expired.',
    },
  ];

  verifyAccount(): void {
    this.isThrottled = false;
    this.maxAllowedTimeToResendOTP = 30;
    clearInterval(this.handleResendTimer);
    this.$store.dispatch('auth/verifyAccount', {
      id: this.$route.query.id,
      code: this.code,
    });
  }

  resendVerificationCode(): void {
    this.handleResendTimer = setInterval(() => {
      if (this.maxAllowedTimeToResendOTP > 0) {
        this.isThrottled = true;
        this.maxAllowedTimeToResendOTP--;
        this.$store.dispatch(
          'snackBarMessage',
          `Resend the code again in ${this.maxAllowedTimeToResendOTP} seconds`,
          {
            root: true,
          }
        );
        this.$store.commit('UPDATE_TIMEOUT', 30000);
        this.$store.dispatch('snackBarVisibility', true, { root: true });
        return;
      }
      this.$store.commit('UPDATE_TIMEOUT', 4000);
      this.$store.dispatch('snackBarMessage', ``, { root: true });
      this.isThrottled = false;
      this.maxAllowedTimeToResendOTP = 30;
      clearInterval(this.handleResendTimer);
    }, 1000);
    this.$store.dispatch('auth/resendVerificationCode', {
      id: this.$route.query.id,
    });
  }

  created(): void {
    if (this.$route.query.id) {
      this.resendVerificationCode();
    }
  }
}
